import { MenuCategoryType } from "types/menus";

export const createDefaultValues = (data: MenuCategoryType | boolean) => {
  if (typeof data === "boolean") {
    return undefined;
  }

  return {
    id: data.id,
    name: data.name,
    name2: data?.name2 || "",
    description: data.description,
    image: data.image,
  };
};
